import C from '../actions/constants'

export const news = (state = [], action) => {
    switch (action.type) {
        case C.SET_NEWS:
            return action.payload
        default:
            return state
    }
}